<template>
  <div
    class="fixed top-0 z-[60] flex h-screen w-64 max-w-[calc(100vw-100px)] shrink-0 flex-col bg-theme-background transition-all"
    :class="[
      expanded
        ? 'shadow-xl dir-ltr:ml-0 dir-rtl:mr-0'
        : 'dir-ltr:-ml-64 dir-rtl:-mr-64',
    ]"
  >
    <ADeepCircleButton class="mb-4 ml-4 mr-4 mt-4" @click="hide">
      <template #icon><XBold /></template>
    </ADeepCircleButton>

    <div
      v-prevent-body-scroll
      class="flex flex-col overflow-y-auto px-4 pb-20 pt-px"
    >
      <CategorySidebarItemCard
        v-for="category in categories"
        :key="category.id"
        :category="category"
        :focused="category.id === focusedCategoryId"
        @click="
          () => {
            hide();
            emit('categoryClick', category);
          }
        "
      />
    </div>
  </div>

  <div
    class="fixed inset-0 z-50 bg-theme-background/50 backdrop-blur transition-all"
    :class="expanded ? 'opacity-100' : 'pointer-events-none opacity-0'"
    @click="hide"
  ></div>
</template>

<script setup lang="ts">
import CategorySidebarItemCard from '@menu/Shared/CategorySidebarItemCard.vue';
import ADeepCircleButton from '@menu/Shared/ADeepCircleButton.vue';
import XBold from '@/phosphoricons/XBold.vue';
import { CategoryResource } from '@menu/Types/Resources/CategoryResource';
import { ref } from 'vue';
import { useEventListener } from '@/composables/useEventListener';

defineProps<{
  categories: CategoryResource[];
  expanded: boolean;
  focusedCategoryId: number | null;
}>();

const emit = defineEmits<{
  hide: [];
  categoryClick: [category: CategoryResource];
}>();

const touchStartX = ref(0);
const touchStartY = ref(0);

const hide = () => emit('hide');

useEventListener(window, 'touchstart', (event) => {
  touchStartX.value = event.changedTouches[0].screenX;
  touchStartY.value = event.changedTouches[0].screenY;
});

useEventListener(window, 'touchend', (event) => {
  const distanceX = event.changedTouches[0].screenX - touchStartX.value;
  const distanceY = event.changedTouches[0].screenY - touchStartY.value;

  if (distanceX < -75 && Math.abs(distanceY) < 75) {
    hide();
  }
});
</script>
